/* ============================================================================
   SPU NAV v3 — drawer behaviour.  Rolled out 10 Sep 2026.

   The hamburger is the site's only menu. Two levels:
     desktop  the department list stays on screen, the pane opens beside it
     mobile   the pane covers the drawer face and carries its own back link

   Four behaviours are load-bearing — each one was a defect the owner caught in
   review, so keep them if this is ever refactored:
     1. the pane closes INDEPENDENTLY of the drawer (its own x / back link)
     2. switching departments REPLAYS the open animation
     3. closing the drawer RESETS the level, so reopening starts at the list
     4. the face drops its transform once the slide finishes, or its text renders
        off the pixel grid and the menu looks soft (.is-settled)

   No dependencies. Safe to load twice. Re-inits on shopify:section:load so the
   theme editor does not need a reload.
   ========================================================================== */
(function () {
  'use strict';

  function init(root) {
    if (!root || root.dataset.spuNav3Ready) return;
    root.dataset.spuNav3Ready = '1';

    var drawer = root.querySelector('[data-spu-dr]');
    var burger = root.querySelector('.nv2-burger');
    if (!drawer || !burger) return;

    var wing = drawer.querySelector('[data-dr-wing]');
    var rows = [].slice.call(drawer.querySelectorAll('[data-dr-open]'));
    var panes = [].slice.call(drawer.querySelectorAll('[data-dr-pane]'));
    var header = burger.closest('.shopify-section') || burger.closest('.site-header');
    var settleTimer = null;
    var openIndex = -1;

    function paneFor(i) {
      for (var n = 0; n < panes.length; n++) {
        if (panes[n].getAttribute('data-dr-pane') === String(i)) return panes[n];
      }
      return null;
    }

    /* (1) closes only the pane — the department list stays open */
    function closePane() {
      openIndex = -1;
      rows.forEach(function (r) {
        r.classList.remove('is-active');
        r.setAttribute('aria-expanded', 'false');
      });
      panes.forEach(function (p) { p.classList.remove('is-open'); });
      if (wing) wing.classList.remove('is-open');
    }

    /* (2) the pane is removed and re-added so the animation replays on switch */
    function openPane(i) {
      var pane = paneFor(i);
      if (!pane) return;
      if (openIndex === i) { closePane(); return; }
      closePane();
      openIndex = i;
      rows.forEach(function (r) {
        var on = r.getAttribute('data-dr-open') === String(i);
        r.classList.toggle('is-active', on);
        r.setAttribute('aria-expanded', on ? 'true' : 'false');
      });
      if (wing) wing.classList.add('is-open');
      /* force a reflow between the class removal and the re-add, otherwise the
         browser coalesces them and the keyframes never run */
      void pane.offsetWidth;
      pane.classList.add('is-open');
    }

    function openDrawer() {
      drawer.classList.add('is-open');
      burger.setAttribute('aria-expanded', 'true');
      document.body.classList.add('spu-dr-locked');
      if (header) header.classList.add('spu-drawer-up');
      /* (4) drop the transform once the slide is done so the text stays crisp */
      clearTimeout(settleTimer);
      settleTimer = setTimeout(function () { drawer.classList.add('is-settled'); }, 260);
      var first = drawer.querySelector('.spu-dr-row');
      if (first) { try { first.focus({ preventScroll: true }); } catch (e) { first.focus(); } }
    }

    /* (3) closing the whole drawer resets the level */
    function closeDrawer() {
      clearTimeout(settleTimer);
      drawer.classList.remove('is-settled');
      drawer.classList.remove('is-open');
      burger.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('spu-dr-locked');
      if (header) header.classList.remove('spu-drawer-up');
      closePane();
    }

    burger.setAttribute('aria-expanded', 'false');
    burger.addEventListener('click', function (e) {
      e.preventDefault();
      if (drawer.classList.contains('is-open')) closeDrawer(); else openDrawer();
    });

    rows.forEach(function (r) {
      r.addEventListener('click', function (e) {
        e.preventDefault();
        openPane(parseInt(r.getAttribute('data-dr-open'), 10));
      });
    });

    [].slice.call(drawer.querySelectorAll('[data-dr-back]')).forEach(function (b) {
      b.addEventListener('click', function (e) { e.preventDefault(); closePane(); });
    });

    [].slice.call(drawer.querySelectorAll('[data-dr-close]')).forEach(function (b) {
      b.addEventListener('click', function (e) { e.preventDefault(); closeDrawer(); });
    });

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape' || !drawer.classList.contains('is-open')) return;
      /* Escape peels one level at a time, like every other two-level menu */
      if (openIndex > -1) closePane(); else { closeDrawer(); burger.focus(); }
    });

    /* keyboard walking of the department list */
    drawer.addEventListener('keydown', function (e) {
      var idx = rows.indexOf(document.activeElement);
      if (idx === -1) return;
      if (e.key === 'ArrowDown') { e.preventDefault(); rows[(idx + 1) % rows.length].focus(); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); rows[(idx - 1 + rows.length) % rows.length].focus(); }
      else if (e.key === 'ArrowRight') {
        e.preventDefault();
        openPane(parseInt(rows[idx].getAttribute('data-dr-open'), 10));
        var link = paneFor(openIndex) && paneFor(openIndex).querySelector('a');
        if (link) link.focus();
      }
    });
  }

  function boot() {
    [].slice.call(document.querySelectorAll('[data-nav-v2]')).forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();
